import { isNumeric } from './math';
import tryCatch from './tryCatch';

const dismissedAlerts = 'dismissedAlerts';

const getOrCreateAlertsStore = (): Record<string, string> => {
  const store = localStorage.getItem(dismissedAlerts);
  if (!store) return {};
  const parsed = tryCatch(() => JSON.parse(store));
  if ({}.toString.call(parsed) !== '[object Object]') return {};
  return parsed;
};

export const isAlertDismissed = (dismissId: string) => {
  const store = getOrCreateAlertsStore();
  const n = +store[dismissId];
  return isNumeric(n) && n > 0;
};

export const getAlertDismissCount = (dismissId: string) => {
  const store = getOrCreateAlertsStore();
  const n = +store[dismissId];
  return isNumeric(n) ? n : 0;
};

export const markAlertAsDismissed = (dismissId: string) => {
  const store = getOrCreateAlertsStore();
  const n = +store[dismissId];
  const dismissCount = Math.min(Math.max(isNumeric(n) ? n + 1 : 1, 1), 100);
  store[dismissId] = String(dismissCount);
  localStorage.setItem(dismissedAlerts, JSON.stringify(store));
};

export const clearAlertDismissed = (dismissId: string) => {
  const store = getOrCreateAlertsStore();
  delete store[dismissId];
  localStorage.setItem(dismissedAlerts, JSON.stringify(store));
};

/** Remove all dismissed alerts whose id starts with the given prefix (e.g. for workspace-scoped banners). */
export const clearAlertDismissedByPrefix = (prefix: string) => {
  const store = getOrCreateAlertsStore();
  let changed = false;
  for (const key of Object.keys(store)) {
    if (key === prefix || key.startsWith(`${prefix}_`)) {
      delete store[key];
      changed = true;
    }
  }
  if (changed) {
    localStorage.setItem(dismissedAlerts, JSON.stringify(store));
  }
};

// is it worth it to make this into a reactive zustand store?
